import { IAppContext } from 'App/AppContext';

export enum LocalStorageKeys {
  NotSet = '',
  UserName = 'REDLAB-Preferred-Username',
  DarkMode = 'REDLAB-DarkMode',
  DarkModeOutlook = 'REDLAB-DarkModeOutlook',
  LocalAccount = 'REDLAB-Local-Account',
  LastSeparateEntraOrgUnit = 'REDLAB-LastSeparateEntraOrgUnit',
  TaskViewType = 'REDLAB-Task-ViewType',
  FieldsPreviewHidden = 'REDLAB-Fields-PreviewHidden',
  KPITrackedCoachSeen = 'REDLAB-KPI-TrackedCoachSeen',
  SharepointOrg = 'REDLAB-SP-Org',
  ShowAllLinks = 'REDLAB-Link-ShowAll',
  QuickFilterAllTasks = 'REDLAB-QuickFilter-AllTasks',
  QuickFilterMyRequests = 'REDLAB-QuickFilter-MyRequests',
  QuickFilterMyTasks = 'REDLAB-QuickFilter-MyTasks',
  QuickFilterMonitoringTasks = 'REDLAB-QuickFilter-MonitoringTasks',
  QuickFilterRisks = 'REDLAB-QuickFilter-Risks',
  QuickFilterTaskContext = 'REDLAB-QuickFilterTaskContext',
  TeamsQuickFilterOnlyMyTasks = 'REDLAB-TeamsQuickFilter-OnlyMyTasks',
  DashboardSortOrderForMe = 'REDLAB-DashboardSortOrderForMe',
  DashboardSortOrderForMyTeams = 'REDLAB-DashboardSortOrderForMyTeams',
  ControlTreeListCache = 'REDLAB-ControlTreeListCache',
  NormTreeListCache = 'REDLAB-NormTreeListCache',
  ThemeTreeListCache = 'REDLAB-ThemeTreeListCache',
  ObjectiveTreeListCache = 'ObjectiveTreeListCache',
  ProcessTreeListCache = 'ProcessTreeListCache',
  AuditYear = 'REDLAB-AuditYear',
  MyTasksListSort = 'REDLAB-MyTasksListSort',
  MyRequestListSort = 'REDLAB-MyRequestListSort',
  AllTasksListSort = 'REDLAB-AllTasksListSort',
  RiskTaskListSort = 'REDLAB-RiskTaskListSort',
  ProcessingActivityTaskListSort = 'REDLAB-ProcessingActivityTaskListSort',
  ControlTaskListSort = 'REDLAB-ControlTaskListSort',
  ThemeTaskListSort = 'REDLAB-ThemeTaskListSort',
  TaskScheduleSort = 'REDLAB-TaskScheduleSort',
  ProcessTaskListSort = 'REDLAB-ProcessTaskListSort',
  ObjectiveTaskListSort = 'REDLAB-ObjectiveTaskListSort',
  SceneFilterTasks = 'REDLAB-SceneFilterTasks',
  SceneFilterSchedule = 'REDLAB-SceneFilterSchedule',
  ScheduleLevel = 'REDLAB-PlanningLevel',
  MyControlsListSort = 'REDLAB-MyControlsListSort',
  MyNormsListSort = 'REDLAB-MyNormsListSort',
  MyObjectivesListSort = 'REDLAB-MyObjectivesListSort',
  MyProcessesListSort = 'REDLAB-MyProcessesListSort',
  MyThemesListSort = 'REDLAB-MyThemesListSort',
  MyRiskListSort = 'REDLAB-RiskListSort',
  SceneFilterOrganization = 'REDLAB-SceneFilterOrganization',
  SceneFilterControl = 'REDLAB-SceneFilterControl',
  SceneFilterTheme = 'REDLAB-SceneFilterTheme',
  SceneFilterRisk = 'REDLAB-SceneFilterRisk',
  SceneFilterNorm = 'REDLAB-SceneFilterNorm',
  SceneFilterLibrary = 'REDLAB-SceneFilterLibrary',
  ShowResourcePanel = 'REDLAB-ShowResourcePanel',
  MainNavCollapsed = 'REDLAB-MainNavCollapsed',
  StandardElementViewMode = 'REDLAB-StandardElementViewMode',
  StandardElementShowInstructions = 'REDLAB-StandardElementShowInstructions',
  StandardElementShowBackground = 'REDLAB-StandardElementShowBackground',
  SceneFilterSentApproval = 'REDLAB-SceneFilterSentApproval',
  AssetViewMode = 'REDLAB-AssetViewMode',
  SceneFilterAsset = 'REDLAB-SceneFilterAsset',
  MyAssetListSort = 'REDLAB-MyAssetListSort',
  QuickFilterAssets = 'REDLAB-QuickFilterAssets',
  AssetTreeListCache = 'REDLAB-AssetTreeListCache',
  RiskSectionsExpanded = 'REDLAB-RiskSectionsExpanded',
  MyKPIListSort = 'REDLAB-MyKPIListSort',
  FormFieldListSort = 'REDLAB-FormFieldListSort',
  QuickFilterKPIs = 'REDLAB-QuickFilterKPIs',
  QuickFilterFormFields = 'REDLAB-QuickFilterFormFields',
  KPIPeriodSelector = 'REDLAB-KPIPeriodSelector',
  KPIAggregationSelector = 'REDLAB-KPIAggregationSelector',
  KPIAggregationIntervalSelector = 'REDLAB-KPIGroupingSelector',
  KPIChartSelector = 'REDLAB-KPIChartSelector',
  RiskColumns = 'REDLAB-RiskColumns',
  AssetColumns = 'REDLAB-AssetColumns',
  QuickFilterObjectives = 'REDLAB-QuickFilterObjectives',
  QuickFilterProcesses = 'REDLAB-QuickFilterProcesses',
  QuickFilterControls = 'REDLAB-QuickFilterControls',
  QuickFilterThemes = 'REDLAB-QuickFilterThemes',
  QuickFilterStandards = 'REDLAB-QuickFilterStandards',
  QuickFilterGeneric = 'REDLAB-QuickFilterGeneric',
  TeamsAppKBOrgUnitMap = 'REDLAB-TeamsAppKBOrgUnitMap',
  TeamsAppMyTasksOrgUnitMap = 'REDLAB-TeamsAppMyTasksOrgUnitMap',
  LibraryColumns = 'REDLAB-LibraryColumns',
  LibraryPublicationColumns = 'REDLAB-LibraryPublicationColumns',
  MyNormsTabAuditStandardSelection = 'REDLAB-MyNormsTabAuditStandardSelection',
  MyNormsTabAuditAccordionImplementation = 'REDLAB-MyNormsTabAuditAccordionImplementation',
  MyNormsTabAuditAccordionContent = 'REDLAB-MyNormsTabAuditAccordionContent',
  ProcessColumns = 'REDLAB-ProcessColumns',
  ObjectiveColumns = 'REDLAB-ObjectiveColumns',
  ControlColumns = 'REDLAB-ControlColumns',
  ThemeColumns = 'REDLAB-ThemeColumns',
  NormColumns = 'REDLAB-NormColumns',
  MyNormsAnalyticsControlSort = 'REDLAB-MyNormsAnalyticsControlSort',
  FormsSort = 'REDLAB-FormsSort',
  GroupListSort = 'REDLAB-GroupListSort',
  AuthSchemaListSort = 'REDLAB-AuthSchemaListSort',
  TaskColumns = 'REDLAB-TaskColumns',
  TaskPeriodSelector = 'REDLAB-TaskPeriodSelector',
  AssetTaskListSort = 'REDLAB-AssetTaskListSort',
  FilterTasksObjective = 'REDLAB-FilterTasksObjective',
  FilterTasksProcess = 'REDLAB-FilterTasksProcess',
  FilterTasksAsset = 'REDLAB-FilterTasksAsset',
  FilterTasksControl = 'REDLAB-FilterTasksControl',
  FilterTasksTheme = 'REDLAB-FilterTasksTheme',
  FilterTasksRisk = 'REDLAB-FilterTasksRisk',
  FilterTasksProcessingActivity = 'REDLAB-FilterTasksProcessingActivity',
  QuickFilterForms = 'REDLAB-QuickFilterForms',
  RiskPeriodSelector = 'REDLAB-RiskPeriodSelector',
  ControlPeriodSelector = 'REDLAB-ControlPeriodSelector',
  TaskCompactView = 'REDLAB-TaskCompactView',
  GlobalSearchRecentSearches = 'REDLAB-GlobalSearchRecentSearches',
  GlobalSearchSharePointSearch = 'REDLAB-GlobalSearchSharePointSearch',
  GlobalFilter = 'REDLAB-GlobalFilter',
  NextStepsExploreOpen = 'REDLAB-NextStepsExploreOpen',
  NextStepsLearnOpen = 'REDLAB-NextStepsLearnOpen',
  NextStepsActionsOpen = 'REDLAB-NextStepsActionsOpen',
  StandardElementExpanded = 'REDLAB-StandardElementExpanded',
  CompanyIntegrationDefaultPivotKey = 'REDLAB-CompanyIntegrationDefaultPivotKey',
  OnlyShowCommentsInActivityTab = 'REDLAB-OnlyShowCommentsInActivityTab',
  CopilotPanelPinned = 'REDLAB-CopilotPanelPinned',
  CopilotPanelUserClosed = 'REDLAB-CopilotPanelUserClosed',
  CopilotPanelGenericDraftSession = 'REDLAB-CopilotPanelGenericDraftSession',
  AuditPeriodSelector = 'REDLAB-AuditPeriodSelector',
  PageContentFitToWidth = 'REDLAB-PageContentFitToWidth',
  SceneFilterProcessingActivity = 'REDLAB-SceneFilterProcessingActivity',
  MyProcessingActivitiesSort = 'REDLAB-MyProcessingActivitiesSort',
  QuickFilterProcessingActivities = 'REDLAB-QuickFilterProcessingActivities',
  ProcessingActivityColumns = 'REDLAB-ProcessingActivityColumns',
  ScoreMatrixShowExplanation = 'REDLAB-ScoreMatrixShowExplanation',
  StringValueMultiSelectAccordionDataCategory = 'REDLAB-StringValueMultiSelectAccordion-DataCategory',
  StringValueMultiSelectAccordionLegalBasis = 'REDLAB-StringValueMultiSelectAccordion-LegalBasis',
  StringValueMultiSelectAccordionDataSubject = 'REDLAB-StringValueMultiSelectAccordion-DataSubject',
  StringValueMultiSelectAccordionExecutingEntity = 'REDLAB-StringValueMultiSelectAccordion-ExecutingEntity',
  StringValueMultiSelectAccordionRecipientCategory = 'REDLAB-StringValueMultiSelectAccordion-RecipientCategory',
  StringValueMultiSelectAccordionRetentionPeriod = 'REDLAB-StringValueMultiSelectAccordion-RetentionPeriod',
  ProcessingResponsibleEntitiesAccordion = 'REDLAB-ProcessingResponsibleEntitiesAccordion',
  ProcessingActivityAssetListAccordionData = 'REDLAB-ProcessingActivityAssetListAccordionData',
  ProcessingActivityAssetListAccordionJointController = 'REDLAB-ProcessingActivityAssetListAccordionJointController',
  ProcessingActivityAssetListAccordionRecipient = 'REDLAB-ProcessingActivityAssetListAccordionRecipient',
  ProcessingActivityAssetListAccordionProcessor = 'REDLAB-ProcessingActivityAssetListAccordionProcessor',
  ProcessingActivitySelectedPivot = 'REDLAB-ProcessingActivitySelectedPivot',
  ProcessingActivityTransfersAccordion = 'REDLAB-ProcessingActivityTransfersAccordion',
  AudienceListSort = 'REDLAB-AudienceListSort',
  LibraryPublicationReportLinkUnreadSort = 'REDLAB-LibraryPublicationReportLinkUnreadSort',
  LibraryPublicationReportLinkReadSort = 'REDLAB-LibraryPublicationReportLinkReadSort',
  LinkPublishResults = 'REDLAB-LinkPublishResults',
  QuickFilterLibrary = 'REDLAB-QuickFilter-Library',
  KPIColumns = 'REDLAB-KPIColumns',
  FormFieldColumns = 'REDLAB-FormFieldColumns',
  QuickFilterPublication = 'REDLAB-QuickFilter-Publication',
  ProcessingActivityComplianceCheckAI = 'REDLAB-ProcessingActivityComplianceCheckAI',
  CompanyAutomationDefaultPivotKey = 'REDLAB-CompanyAutomationDefaultPivotKey',
  Integration_MS_MFA_Report = 'REDLAB-Integration_MS_MFA_Report',
  Integration_MS_MFA_Exemptions = 'REDLAB-Integration_MS_MFA_Exemptions',
  Integration_MS_MFA_Exemptions_CA = 'REDLAB-Integration_MS_MFA_Exemptions_CA',
  TaskScheduleRunSortTask = 'REDLAB-TaskScheduleRunSortTask',
  TaskScheduleRunSortError = 'REDLAB-TaskScheduleRunSortError',
  ExportEvidenceShowCompanyLogo = 'REDLAB-ExportEvidenceShowCompanyLogo',
  ExportEvidenceShowEvidenceHeader = 'REDLAB-ExportEvidenceShowEvidenceHeader',
  ExportEvidenceShowOriginalHeader = 'REDLAB-ExportEvidenceShowOriginalHeader',
  ExportEvidenceShowAdditionalDetails = 'REDLAB-ExportEvidenceShowAdditionalDetails',
  ExportEvidenceEnableLinks = 'REDLAB-ExportEvidenceEnableLinks',
  Integration_SslLabs_Targets = 'REDLAB-Integration_SslLabs_Targets',
  Integration_SslLabs_Results = 'REDLAB-Integration_SslLabs_Results',
}

function getLocalStorageName(appContext: IAppContext | undefined, name: LocalStorageKeys): string {
  let storageName: string = name;
  if (appContext && appContext.user.tenant.id) {
    storageName += `-${appContext.user.tenant.id}`;
  }

  return storageName;
}

export function setLocalStorageData(
  appContext: IAppContext | undefined,
  name: LocalStorageKeys,
  value: string,
  tenantSpecific: boolean = true,
) {
  try {
    if (name === LocalStorageKeys.NotSet) return;
    let storageName: string = name;
    if (tenantSpecific) {
      storageName = getLocalStorageName(appContext, name);
    }
    window.localStorage.setItem(storageName, value);
  } catch {
    // no-op
  }
}

export function getLocalStorageData(appContext: IAppContext | undefined, name: LocalStorageKeys): string | undefined {
  try {
    if (name === LocalStorageKeys.NotSet) return;

    const storageName = getLocalStorageName(appContext, name);
    let val = window.localStorage.getItem(storageName);
    if (val === null && storageName !== name) {
      val = window.localStorage.getItem(name);
    }

    if (!val) return undefined;

    return val;
  } catch {
    return undefined;
  }
}

export function removeLocalStorageData(appContext: IAppContext | undefined, name: LocalStorageKeys) {
  try {
    if (name === LocalStorageKeys.NotSet) return;

    const storageName = getLocalStorageName(appContext, name);
    window.localStorage.removeItem(name);
    window.localStorage.removeItem(storageName);
  } catch {
    // no-op
  }
}

export function removeAllLocalStorageData() {
  try {
    window.localStorage.clear();
  } catch {
    // no-op
  }
}
